export enum FREQUENCY {
  ONCE = 'ONCE',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}
export type Frequency = keyof typeof FREQUENCY;

export enum ONCE_SCHEDULE_DATE_OPTION {
  TODAY = 'TODAY',
  FUTURE = 'FUTURE'
}

export enum REPORTING_TIMEZONE_OPTION {
  CAMPAIGN_TIMEZONE = 'CAMPAIGN_TIMEZONE',
  UTC = 'UTC'
}

export enum MONTHLY_SCHEDULE_DAY_OPTION {
  DAY = 'DAY',
  LAST_DAY = 'LAST_DAY'
}

/**
 * This enum categorizes schedules into IMMEDIATE and SCHEDULED
 * This is used to determine the label of create subscription button
 * It is also used to determine if a spoofer can create subscription based on schedule options
 */
export enum SCHEDULE_TYPE {
  IMMEDIATE = 'IMMEDIATE',
  SCHEDULED = 'SCHEDULED'
}
